export default {"src":"/_next/static/media/investment-icon-selected.430a9a4c.svg","height":76,"width":94,"blurWidth":0,"blurHeight":0};